<script lang="ts" setup>
defineProps<{
  label: string;
  products: number[];
  isActive?: boolean;
}>();

const emit = defineEmits(['selected']);
</script>

<template>
  <label class="pick-a-card-category-tag configurator-pick-a-card_filter" @change.prevent="emit('selected')">
    <span>{{ label }}</span>

    <input type="radio" name="card-category-tag" :value="label" :checked="isActive" />
  </label>
</template>
